import React, { useEffect, useState } from 'react';
import { Breadcrumb, Layout, theme, Row, Col, Form, Button, Modal, Select, Input, Image, Typography, Table,Spin ,message, Card, Tag, Space, Switch, Tooltip, Popconfirm } from 'antd';
import { EditOutlined, DeleteOutlined, UnorderedListOutlined ,ExclamationCircleOutlined, CloseCircleFilled, CheckCircleFilled,} from '@ant-design/icons';
import Headerdiv from "../layout/header";
import Footerdiv from "../layout/footer";
import { useNavigate } from "react-router-dom";
import { MAINAPIURL,APPBACKGROUND_COLOR } from '../appsettings.js';
import axios from 'axios';
import { AlertError, AlertSuccess } from '../usableclasses.js';

const { Content } = Layout;
const { Option } = Select;
const { Title, Text } = Typography;


function VendorManagement() {
    const ApiURL = MAINAPIURL;
    const TOKEN = localStorage.getItem("AUTHCODE");
    const UPDATED_BY = localStorage.getItem("USERID");
    const { token: { colorBgContainer, borderRadiusLG }, } = theme.useToken();


    const [vendors, setVendors] = useState([]);
    const [loading, setLoading] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const navigate = useNavigate();
    useEffect(() => {
        fetchVendors();
    }, []);

    const fetchVendors = async () => {
        setLoading(true);
        try {
            const headers = { SystemAccessToken: TOKEN };
            const response = await axios.get(`${ApiURL}/vendor/listall`, { headers });
            setVendors(response.data);
        } catch (error) {
            AlertError("Failed to fetch vendors.");
        } finally {
            setLoading(false);
        }
    };

    const confirmDeleteVendor = (vendorId) => {
        Modal.confirm({
            title: "Are you sure you want to delete this vendor?",
            icon: <ExclamationCircleOutlined />,
            content: "This action cannot be undone.",
            okText: "Yes, Delete",
            okType: "danger",
            cancelText: "Cancel",
            onOk: () => deleteVendor(vendorId),
        });
    };

    const deleteVendor = async (vendorId) => {
        setDeleting(true);
        try {
            const headers = { SystemAccessToken: TOKEN };
            const response = await axios.get(`${ApiURL}/vendor/delete/${vendorId}`, { headers });

            if (response.status === 200) {
                AlertSuccess("Vendor deleted successfully.");
                fetchVendors();
            }
        } catch (error) {
            AlertError("Failed to delete vendor.");
        } finally {
            setDeleting(false);
        }
    };


  



    const columns = [
        {
            title: "Actions",
            key: "actions",
            fixed: "left",
            render: (_, record) => (
                <Space>
                    <Tooltip title="Edit">
                        <Button type="link" icon={<EditOutlined />} onClick={() => navigate(`/master/vendorupdate/${record.vendorId}`)}/>
                    </Tooltip>
                    <Popconfirm
                        title="Are you sure to delete this brand?"
                        onConfirm={() => deleteVendor(record.vendorId)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Tooltip title="Delete">
                            <Button type="link" danger icon={<DeleteOutlined />} />
                        </Tooltip>
                    </Popconfirm>
                    
                </Space>
            ),
        },
       // { title: "ID", dataIndex: "vendorId", key: "vendorId" },
        { title: "Type", dataIndex: "vendorType", key: "vendorType" },
        { title: "Name", dataIndex: "vendorName", key: "vendorName" },
        { title: "Office Line", dataIndex: "vendorOfficeLine", key: "vendorOfficeLine" },
        { title: "Hotline", dataIndex: "vendorHotline", key: "vendorHotline" },
        { title: "Email", dataIndex: "vendorEmail", key: "vendorEmail" },
        { title: "Current Balance", dataIndex: "vendorCurrentBalance", key: "vendorCurrentBalance" },
        {
            title: "Is Verified",
            dataIndex: "vendorIsVerified",
            key: "vendorIsVerified",
            align: "center",
            width: 100,
            render: (vendorIsVerified) =>
                vendorIsVerified === true ? (
                <Tooltip title="Verified">
                  <CheckCircleFilled style={{ color: "green", fontSize: "18px" }} />
                </Tooltip>
              ) : (
                <Tooltip title="Not Verified">
                  <CloseCircleFilled style={{ color: "red", fontSize: "18px" }} />
                </Tooltip>
              ),
          },
        {
            title: 'Status',
            dataIndex: 'vendorIsActive',
            key: 'vendorIsActive',
            render: (vendorIsActive) => (
                <Tag color={vendorIsActive === true ? "green" : "red"}>
                    {vendorIsActive === true ? "Active" : "Inactive"}
                </Tag>
            ),
            align: "center",
        },
    ];

    return (
        <Spin spinning={loading} tip="Processing...">
            <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
                <Headerdiv />
                <Content style={{ padding: '10px', }} >
                    <Breadcrumb style={{ margin: "16px 0" }}>
                        <Breadcrumb.Item>Master</Breadcrumb.Item>
                        <Breadcrumb.Item >Vendor Management</Breadcrumb.Item> 
                    </Breadcrumb>
                    <div style={{ padding: 10, minHeight: '65vh', background: colorBgContainer, borderRadius: borderRadiusLG, }} >
                        <Space
                            direction="vertical"
                            style={{ width: "100%", padding: "15px" }}
                        >
                            <Row>
                            <Col xs={24} style={{ textAlign: "right",marginBottom:'10px' }}>
                                <Button type="primary" onClick={() => navigate("/master/vendorcreate")}>Create New</Button>
                            </Col>

                        </Row>

                            <Typography.Title level={5}>List of Vendors</Typography.Title>
                            <Table
                                columns={columns}
                                dataSource={vendors}
                                rowKey="vendorId"
                                pagination={{ pageSize: 5 }}
                                scroll={{ x: 1000 }}
                            />
                        </Space>
                    </div>
                </Content>
                <Footerdiv />


            </Layout>
        </Spin>
    );
}

export default VendorManagement;